

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar'; // Import the Navbar component
import HomePage from './components/Home'; 
import Shop from './components/Shop'; 
import Login from './components/Login'; 
import Logout from './components/Logout'; 
import Register from './components/Register';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import AccountPage from './components/UserAccountPage';
import OrdersPage from './components/Orders';
import OrderConfirmation from './components/OrderConfirmationPage';
import DetailProduct from './components/ProductDetail';
import RegisterBusiness from './components/biz/RegisterBusiness';
import BusinessDashboard from './components/biz/BusinessDashboard';
import BusinessDetail from './components/BusinessDetail';
import UserAccountPage from './components/UserAccountPage';
import ResetConfirm from './components/ResetConfirm';
import ResetPassword from './components/ResetPassword';
import FooterReal from './components/FooterReal';
import FAQSection from './components/FAQSection';
import VerifyingSustainability from './components/VerifyingSustainability';
import OurStory from './components/OurStory';
import Partners from './components/Partners';
import EcoPersonaQuiz from './components/EcoPersonaQuiz';
import ForBusinesses from './components/ForBusinesses';

import {UserAccountRoutes} from './components/UserAccountPage';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Include Navbar here to show on all pages */}
        <Navbar />

        <Routes>
          {/* Routes for different pages */}
          <Route path="/" element={<HomePage />} /> {/* HomePage Component */}
          <Route path="/shop" element={<Shop />} /> {/* Shop Component */}
          <Route path="/shop/products/:productId" element={<DetailProduct />} />
          {/* //<Route path="/logout" element={<Logout/>}/> */}
          <Route path="/login" element={<Login/>}/>
          <Route path="/cart" element={<Cart/>}/>
          <Route path="/logout" element={<Logout/>}/>
          <Route path="/register" element={<Register />} />
          <Route path="/checkout" element={<Checkout />} /> {/* New Checkout Route */}
          <Route path="/account" element={<AccountPage />} />
          <Route path="/myorders" element={<OrdersPage />} />
          <Route path="/registerbusiness" element={<RegisterBusiness/>} />
          <Route path="dashboard/" element={<BusinessDashboard/>} />
          <Route path="businessproducts/:businessId" element={<BusinessDetail />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/password-reset" element={<ResetPassword />} />
          <Route path="/faqs" element={<FAQSection/>} />
          <Route path="/sustainability" element={<VerifyingSustainability/>} />
          <Route path="/our-story" element={<OurStory/>} />
          <Route path="/partners" element={<Partners/>} />
          <Route path="/quiz" element={<EcoPersonaQuiz/>} />
          <Route path="/for-businesses" element={<ForBusinesses/>} />

        <Route path="/password-reset-confirm/:uid/:token" element={<ResetConfirm />} />

          <Route path="/account/*" element={<UserAccountRoutes />} /> {}

       </Routes>
       <FooterReal />
      </div>
      
    </Router>
  );
}

export default App;
